export default __webpack_public_path__ + "static/media/monarch_logo_dark.bd230bec.svg";